import createReducer from 'arts/config/create_reducer';
import Constants from '../config/const';

const getDefaultState = () => ({
  walls: [],
  loading: false,
  loaded: false
});

const favoriteWallsReducer = createReducer(getDefaultState(), {
  [Constants.favoriteWalls.load]: (state) => ({
    ...state,
    loading: true
  }),
  [Constants.favoriteWalls.success]: (state, { walls }) => ({
    ...state,
    walls,
    loading: false,
    loaded: true
  })
});

export default favoriteWallsReducer;
